import { createAction, createActionGroup, props } from '@ngrx/store'
import { CTC, EmployeeSalary, SalaryData, StatutoryCompliances } from './employee-salary.state'

// Load All Salaries
export const loadAllSalaries = createAction(
  '[EmployeeSalary] Load All Salaries',
  props<{ employeeId: string; belongsTo: string | null }>()
)

export const loadAllSalariesSuccess = createAction(
  '[EmployeeSalary] Load All Salaries Success',
  props<{ salaries: EmployeeSalary[] }>()
)

export const loadAllSalariesFailure = createAction(
  '[EmployeeSalary] Load All Salaries Failure',
  props<{ error: string }>()
)

// Load Salary
export const loadSalary = createAction(
  '[EmployeeSalary] Load Salary',
  props<{ employeeId: string; belongsTo: string | null }>()
)

export const loadSalarySuccess = createAction(
  '[EmployeeSalary] Load Salary Success',
  props<{ salary: EmployeeSalary }>()
)

export const loadSalaryFailure = createAction(
  '[EmployeeSalary] Load Salary Failure',
  props<{ error: string }>()
)

// Add parts of Salary
export const addBusinessRequirements = createAction(
  '[EmployeeSalary] Add Business Requirements',
  props<{ businessRequirements: { belongsTo: string; employeeId: string } }>()
)
export const addStatutoryCompliances = createAction(
  '[EmployeeSalary] Add Statutory Compliances',
  props<{ statutoryCompliances: StatutoryCompliances }>()
)
export const addCtcValue = createAction(
  '[EmployeeSalary] Add CTC Value',
  props<{ ctcValue: number }>()
)
export const addCtc = createAction('[EmployeeSalary] Add CTC', props<{ ctc: CTC }>())
export const addSalaryData = createAction(
  '[EmployeeSalary] Add Salary Data',
  props<{ salaryData: SalaryData }>()
)

// Add Complete Salary
export const addSalary = createAction(
  '[EmployeeSalary] Add Salary',
  props<{ salary: EmployeeSalary }>()
)

export const addSalarySuccess = createAction(
  '[EmployeeSalary] Add Salary Success',
  props<{ salary: EmployeeSalary }>()
)

export const addSalaryFailure = createAction(
  '[EmployeeSalary] Add Salary Failure',
  props<{ error: string }>()
)

// Edit Salary
export const editSalary = createAction(
  '[EmployeeSalary] Edit Salary',
  props<{ salary: EmployeeSalary }>()
)

export const editSalarySuccess = createAction(
  '[EmployeeSalary] Edit Salary Success',
  props<{ salary: EmployeeSalary }>()
)

export const editSalaryFailure = createAction(
  '[EmployeeSalary] Edit Salary Failure',
  props<{ error: string }>()
)

// Delete Salary
export const deleteSalary = createAction('[EmployeeSalary] Delete Salary', props<{ id: string }>())

export const deleteSalarySuccess = createAction(
  '[EmployeeSalary] Delete Salary Success',
  props<{ id: string }>()
)

export const deleteSalaryFailure = createAction(
  '[EmployeeSalary] Delete Salary Failure',
  props<{ error: string }>()
)

// Clear Salary State
export const clearSalaryState = createAction('[EmployeeSalary] Clear Salary')

// --- Revision Workflow Actions ---
export const salaryRevisionActions = createActionGroup({
  source: 'Salary Revision',
  events: {
    'Initiate Salary Revision': props<{
      belongsTo: string | null
      employeeId: string
    }>(),
    'Update Statutory Compliances': props<{
      statutoryCompliances: StatutoryCompliances
    }>(),
    'Update CTC Value': props<{ ctcValue: number }>(),
    'Update CTC': props<{ ctc: CTC }>(),
    'Update Salary Data': props<{ salaryData: SalaryData }>(),

    'Save Revised Salary': props<{ salary: EmployeeSalary }>(),
    'Save Revised Salary Success': props<{ salary: EmployeeSalary }>(),
    'Save Revised Salary Failure': props<{ error: string }>()
  }
})

//Load all salaries by businessId
//TODO: Confirm usages of this action
//export const loadAllSalariesByBusinessId = createActionGroup({
//  source: 'Load All Salaries By Business Id',
//  events: {
//    'Load Salaries': props<{ businessId: string }>(),
//    'Load Salaries Success': props<{ salaries: EmployeeSalaryWithUser[] }>(),
//    'Load Salaries Failure': props<{ error: string }>()
//  }
//})
